window.app = window.app || {};

window.app.activitiesList = {
  api: {
    content: 'https://public-dot-blazepod-apps-85c6f.uc.r.appspot.com/public/v1/contents',
    filters: 'https://public-dot-blazepod-apps-85c6f.uc.r.appspot.com/public/v1/filters'
  },
  data: window.sessionStorage.getItem('bpActivities') ? JSON.parse(window.sessionStorage.getItem('bpActivities')) : [],
  filtersData: window.sessionStorage.getItem('bpActivitiesFilters') ? JSON.parse(window.sessionStorage.getItem('bpActivitiesFilters')) : [],
  lastUpdated: window.sessionStorage.getItem('bpActivitiesTS') ? Number(window.sessionStorage.getItem('bpActivitiesTS')) : null,
  createdByConfig: [],
  el: {
    section: document.querySelector('.mt-activities-list'),
    content: document.querySelector('.mt-activities-list__content'),
    loadMoreWrapper: document.querySelector('.mt-activities-list__action'),
    loadMore: document.querySelector('.mt-activities-list__load-more'),
    filters: document.querySelector('.mt-activities-filters'),
    filtersWrapper: document.querySelector('.mt-activities-list__filters'),
    filtersToggleBtn: document.querySelector('.mt-activities-list__filters-btn'),
    filtersClearBtn: document.querySelector('.mt-activities-filters__clear-all'),
    filtersGroupsWrapper: document.querySelector('.mt-activities-filters__groups'),
    filtersGroups: document.querySelectorAll('.mt-activities-filters__group'),
    creators: document.querySelector('.mt-featured-creators'),
    creatorsSlider: document.querySelector('.mt-featured-creators .swiper'),
    modal: {
      el: document.querySelector('.mt-modal--activity'),
      title: document.querySelector('.mt-activity-info__title'),
      authorName: document.querySelector('.mt-activity-info__author-name span:nth-child(1)'),
      authorSubtitle: document.querySelector('.mt-activity-info__author-name span:nth-child(2)'),
      authorImage: document.querySelector('.mt-activity-info__author-image'),
      fields: document.querySelector('.mt-activity-info__list--fields'),
      goals: document.querySelector('.mt-activity-info__list--goals'),
      setupPlayers: document.querySelector('.mt-activity-info__setup-item[data-type="players"]'),
      setupPods: document.querySelector('.mt-activity-info__setup-item[data-type="pods"]'),
      setupDuration: document.querySelector('.mt-activity-info__setup-item[data-type="duration"]'),
      gallery: document.querySelector('.mt-activity-info__gallery'),
      gallerySwiper: document.querySelector('.mt-activity-gallery'),
      galleryWrapper: document.querySelector('.mt-activity-gallery .swiper-wrapper')
    }
  },

  fetchActivites: async function () {
    const _this = this;

    try {
      let data = await fetch(_this.api.content);
      data = await data.json();
      _this.data = data;
      window.sessionStorage.setItem('bpActivities', JSON.stringify(_this.data));
      window.sessionStorage.setItem('bpActivitiesTS', new Date().getTime());
    } catch (e) {
      console.log("Error (cannot to fetch activities)", e);
    }
  },

  fetchFilters: async function () {
    const _this = this;

    try {
      let data = await fetch(_this.api.filters);
      data = await data.json();
      _this.filtersData = data.concat(_this.filtersData);
      _this.filtersData.push({ group_name: 'Activity Creator', element: [..._this.createdByConfig.map(filter => filter.title)] });
      window.sessionStorage.setItem('bpActivitiesFilters', JSON.stringify(_this.filtersData));
    } catch (e) {
      console.log("Error (cannot to fetch filters)", e);
    }
  },

  handleize: function (str) {
    return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
  },

  render: function () {
    const _this = this;
    const itemsPerPage = Number(_this.el.content.dataset.page);
    const icon = {
      close: document.querySelector('.mt-activites-icons .mt-icon--x'),
      duration: document.querySelector('.mt-activites-icons .mt-icon--timer'),
      player: document.querySelector('.mt-activites-icons .mt-icon--player'),
      pods: document.querySelector('.mt-activites-icons .mt-icon--pods'),
    };
    const defaultAvatar = window.activitesCreatorsAvatar ? window.activitesCreatorsAvatar : '';
    let contentHtml = '';

    if (_this.data.length === 0) return;

    // Update creators (config)
    _this.createdByConfig = [
      { title: 'BlazePod Activities', includes: ['BlazePod'] },
      { title: 'Community Activities', includes: [...new Set(_this.data.filter(item => item.creator !== 'BlazePod').map(item => item.creator))] }
    ];

    // Activities list
    _this.data.forEach(({ cover, creator, app_user_id, fields, goals, media, settings, name, share_link }, i) => {
      // Creator details
      let creatorObj = activitiesCreators.find(cr => cr.app_id === app_user_id) || (activitiesCreators.find(cr => cr.name === creator) || { name: creator, subtitle: '', image: defaultAvatar });
      (creatorObj.name !== creator) && (creatorObj.name = creator);
      creatorObj.image.includes('no-image') && (creatorObj.image = defaultAvatar);

      const item = document.createElement('div');
      item.classList = (i < itemsPerPage) ? 'mt-activity' : 'mt-activity hidden';
      item.dataset.id = i;
      _this.data[i].id = i;

      // Media (Gallery)
      const itemMedia = document.createElement('div');
      itemMedia.classList = 'mt-activity__media';
      cover && (itemMedia.innerHTML = `<img src="${cover}" alt="${name}" loading="lazy">`);

      const itemVideo = media.filter(m => m.type === 'video');
      if (itemVideo.length > 0) {
        const itemMediaVideo = document.createElement('video');
        itemMediaVideo.setAttribute('data-src', itemVideo[0].url);
        itemMediaVideo.setAttribute('playsinline', '');
        itemMediaVideo.setAttribute('muted', '');
        itemMediaVideo.setAttribute('loop', '');
        itemMediaVideo.setAttribute('controlsList', 'nofullscreen nodownload noremoteplayback');
        itemMedia.appendChild(itemMediaVideo);
      }

      // Main content
      const itemContent = document.createElement('div');
      itemContent.classList = 'mt-activity__content';

      // Actions
      const itemActions = document.createElement('div');
      itemActions.classList = 'mt-activity__actions';

      // Title
      const itemTitle = document.createElement('p');
      itemTitle.classList = 'mt-activity__title';
      itemTitle.innerHTML = name;

      // Fields
      const itemFields = document.createElement('p');
      itemFields.classList = 'mt-activity__fields';
      itemFields.innerHTML = fields.join(' • ');

      // Goals
      const itemGoals = document.createElement('p');
      itemGoals.classList = 'mt-activity__goals';
      itemGoals.innerHTML = goals.join(' • ');

      // Info button
      const itemInfoButton = document.createElement('button');
      itemInfoButton.classList = 'mt-activity__info-button';
      itemInfoButton.type = 'button';

      // Action: Share
      if (share_link !== null) {
        const itemActionShare = document.createElement('a');
        itemActionShare.classList = 'mt-activity__action mt-activity__action-share';
        itemActionShare.href = share_link;
        itemActions.appendChild(itemActionShare);
      }

      // Action: Save
      if (share_link !== null) {
        const itemActionSave = document.createElement('a');
        itemActionSave.classList = 'mt-activity__action mt-activity__action-save';
        itemActionSave.href = share_link;
        itemActions.appendChild(itemActionSave);
      }

      // Action: Author
      const itemActionAuthor = document.createElement('div');
      itemActionAuthor.classList = 'mt-activity__action mt-activity__action-author';
      itemActionAuthor.innerHTML = `<img src="${creatorObj.image}" alt="${creator}">`;
      itemActions.appendChild(itemActionAuthor);

      // Info
      const itemInfo = document.createElement('div');
      itemInfo.classList = 'mt-activity__info';
      itemInfo.innerHTML = `<div class="mt-activity__author">
          <div class="mt-activity__author-image"><img src="${creatorObj.image}" alt="${creator}"></div>
          <p class="mt-activity__author-name"><span>${creator}</span><span>${creatorObj ? creatorObj.subtitle : ''}</span></p>
        </div>`;

      // Mobile Details
      const itemDetails = document.createElement('div');
      itemDetails.classList = 'mt-activity__details mt-activity-details';

      const itemDetailsClose = document.createElement('button');
      itemDetailsClose.classList = 'mt-activity-details__close';
      itemDetailsClose.type = 'button';
      itemDetailsClose.innerHTML = icon.close.outerHTML;

      const itemDetailsTitle = document.createElement('p');
      itemDetailsTitle.classList = 'mt-activity-details__title';
      itemDetailsTitle.innerHTML = name;

      const itemDetailsAuthor = document.createElement('div');
      itemDetailsAuthor.classList = 'mt-activity-details__author';
      itemDetailsAuthor.innerHTML = `<div class="mt-activity-details__author-image">
          <img src="${creatorObj.image}" alt="${creator}">
        </div>
        <p class="mt-activity-details__author-name">
          <span>${creator}</span>
          <span>${creatorObj ? creatorObj.subtitle : ''}</span>
        </p>`;

      let itemDetailsFields;
      if (fields.length > 0) {
        itemDetailsFields = document.createElement('div');
        itemDetailsFields.classList = 'mt-activity-details__list mt-activity-details__list--fields';
        const itemDetailsFieldsList = document.createElement('ul');
        let itemFieldsHtml = ''; fields.forEach(field => (itemFieldsHtml += `<li>${field}</li>`));
        itemDetailsFieldsList.innerHTML = itemFieldsHtml;
        itemDetailsFields.innerHTML = '<p>Field</p>';
        itemDetailsFields.appendChild(itemDetailsFieldsList);
      }

      let itemDetailsGoals;
      if (goals.length > 0) {
        itemDetailsGoals = document.createElement('div');
        itemDetailsGoals.classList = 'mt-activity-details__list mt-activity-details__list--goals';
        const itemDetailsGoalsList = document.createElement('ul');
        let itemGoalsHtml = ''; goals.forEach(goal => (itemGoalsHtml += `<li>${goal}</li>`));
        itemDetailsGoalsList.innerHTML = itemGoalsHtml;
        itemDetailsGoals.innerHTML = '<p>Activity Goals</p>';
        itemDetailsGoals.appendChild(itemDetailsGoalsList);
      }

      const itemDetailsSetup = document.createElement('div');
      itemDetailsSetup.classList = 'mt-activity-details__setup';
      itemDetailsSetup.innerHTML = '<p>Setup</p>';

      const itemDetailsSetupList = document.createElement('div');
      itemDetailsSetupList.classList = 'mt-activity-details__setup-list';

      let itemDetailsDuration;
      if (settings.duration !== null) {
        itemDetailsDuration = document.createElement('div');
        itemDetailsDuration.classList = 'mt-activity-details__setup-item';
        itemDetailsDuration.innerHTML = `<div class="mt-activity-details__setup-item__icon">${icon.duration.outerHTML}</div><div class="mt-activity-details__setup-item__text"><span>${(settings.duration / 1000)}s</span><span>Duration</span></div>`;
        itemDetailsSetupList.appendChild(itemDetailsDuration);
      }

      let itemDetailsPlayers;
      if (settings.players !== null) {
        itemDetailsPlayers = document.createElement('div');
        itemDetailsPlayers.classList = 'mt-activity-details__setup-item';
        itemDetailsPlayers.innerHTML = `<div class="mt-activity-details__setup-item__icon">${icon.player.outerHTML}</div><div class="mt-activity-details__setup-item__text"><span>${settings.players}</span><span>Players</span></div>`;
        itemDetailsSetupList.appendChild(itemDetailsPlayers);
      }

      let itemDetailsPods;
      if (settings.pods !== null) {
        itemDetailsPods = document.createElement('div');
        itemDetailsPods.classList = 'mt-activity-details__setup-item';
        itemDetailsPods.innerHTML = `<div class="mt-activity-details__setup-item__icon">${icon.pods.outerHTML}</div><div class="mt-activity-details__setup-item__text"><span>${settings.pods}</span><span>Pods</span></div>`;
        itemDetailsSetupList.appendChild(itemDetailsPods);
      }

      // Build activity card
      itemMedia.appendChild(itemActions);
      itemContent.appendChild(itemTitle);
      itemContent.appendChild(itemFields);
      itemContent.appendChild(itemGoals);
      itemContent.appendChild(itemInfo);
      itemContent.appendChild(itemInfoButton);
      itemDetails.appendChild(itemDetailsClose);
      itemDetails.appendChild(itemDetailsTitle);
      itemDetails.appendChild(itemDetailsAuthor);
      (fields.length > 0) && itemDetails.appendChild(itemDetailsFields);
      (goals.length > 0) && itemDetails.appendChild(itemDetailsGoals);
      (itemDetailsSetupList.innerHTML !== '') && itemDetailsSetup.appendChild(itemDetailsSetupList);
      (itemDetailsSetupList.innerHTML !== '') && itemDetails.appendChild(itemDetailsSetup);
      itemDetails.appendChild(itemDetailsSetup);
      item.appendChild(itemMedia);
      item.appendChild(itemContent);
      item.appendChild(itemDetails);

      contentHtml += item.outerHTML;
    });

    // No results
    const noResults = document.createElement('div');
    noResults.classList = 'mt-activities-list__no-results';
    noResults.innerHTML = `<p>No matches found for selected filters</p>`;
    contentHtml += noResults.outerHTML;

    _this.el.content.innerHTML = contentHtml;

    _this.createEvents();
    _this.loadMore.init();
  },

  createEvents: function () {
    const _this = this;
    const items = document.querySelectorAll('.mt-activity');
    const isVideoPlaying = video => !!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2);
    const updateItemWidth = () => {
      const item = document.querySelector('.mt-activity:not(.hidden)');
      if (!item) return;
      _this.el.section.style.setProperty('--activity-width', item.offsetWidth + 'px');
    };
    const observerCallback = (entries, observer) => {
      entries.forEach((entry) => {
        const item = entry.target;
        const itemVideo = item.querySelector('.mt-activity__media video');
        if (itemVideo && entry.intersectionRatio > 0) {
          if (itemVideo.getAttribute('data-src') !== null) {
            itemVideo.setAttribute('src', itemVideo.getAttribute('data-src'));
            itemVideo.setAttribute('preload', 'auto');
            itemVideo.removeAttribute('data-src');
            itemVideo.load();
          }
        }
        if (window.innerWidth <= 768 && itemVideo.getAttribute('src') !== '' && entry.intersectionRatio > 0.2) {
          item.classList.add('mt-activity--video-visible');
          itemVideo.play();
          setTimeout(() => isVideoPlaying(itemVideo) ? itemVideo.removeAttribute('controls') : itemVideo.setAttribute('controls', true), 500);
        }
        if (itemVideo && itemVideo.getAttribute('src') !== '' && entry.intersectionRatio <= 0.7) {
          item.classList.remove('mt-activity--video-visible');
          itemVideo.pause();
        }
      });
    };
    const observer = new IntersectionObserver(observerCallback, {
      root: null,
      rootMargin: "0px",
      threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
    });

    // Items
    items.forEach((item, i) => {
      // Item media (video)
      const itemVideo = item.querySelector('.mt-activity__media video');
      if (itemVideo) {
        observer.observe(item);
        item.addEventListener('mouseenter', () => itemVideo.play());
        item.addEventListener('mouseleave', () => itemVideo.pause());
        itemVideo.addEventListener('play', () => itemVideo.removeAttribute('controls'));

        // Load first 4 videos
        if (i < 4 && itemVideo.getAttribute('data-src') !== null) {
          itemVideo.setAttribute('src', itemVideo.getAttribute('data-src'));
          itemVideo.removeAttribute('data-src');
          itemVideo.load();
        }
      }

      // Share button
      const shareButton = item.querySelector('.mt-activity__action-share');
      shareButton && shareButton.addEventListener('click', e => {
        e.preventDefault();
        if (navigator.clipboard) {
          navigator.clipboard.writeText(shareButton.href);
          const tooltip = shareButton.querySelector('.tooltip');
          tooltip && tooltip.remove();
          const el = document.createElement('div');
          el.classList.add('tooltip');
          el.innerText = "Copied to clipboard!";
          shareButton.appendChild(el);
          setTimeout(() => el.classList.add('active'), 1);
          setTimeout(() => el.classList.remove('active'), 2000);
          setTimeout(() => el.remove(), 2300);
        }
      });

      // Item x Modal (desktop)
      item.addEventListener('click', e => {
        if ((e.target.classList.contains('mt-activity__content') || e.target.closest('.mt-activity__content')) && window.innerWidth <= 768) {
          item.classList.add('active');
          return;
        }
        if (e.target.classList.contains('mt-activity__action') || window.innerWidth <= 768) return;

        e.preventDefault();

        const itemData = _this.data[Number(item.dataset.id)];
        const defaultAvatar = window.activitesCreatorsAvatar ? window.activitesCreatorsAvatar : '';
        let creatorObj = activitiesCreators.find(cr => cr.app_id === itemData.app_user_id) || (activitiesCreators.find(cr => cr.name === itemData.creator) || { name: itemData.creator, subtitle: '', image: defaultAvatar });
        (creatorObj.name !== itemData.creator) && (creatorObj.name = itemData.creator);
        creatorObj.image.includes('no-image') && (creatorObj.image = defaultAvatar);


        if (itemData && _this.el.modal.el) {
          // Gallery
          let galleryHtml = '';
          itemData.media.forEach((media, i) => {
            if (itemData.creator !== 'BlazePod' && itemData.media.length > 1 && i === 0) return;
            if (media.type == 'video') {
              galleryHtml += `<div class="swiper-slide">
                <figure class="mt-activity-gallery__item mt-activity-gallery__item--video">
                  <video src="${media.url}" class="mt-activity-gallery__video" playsinline autoplay loop></video>
                </figure>
              </div>`;
            } else {
              galleryHtml += `<div class="swiper-slide">
                <figure class="mt-activity-gallery__item mt-activity-gallery__item--image">
                  <img src="${media.url}" class="mt-activity-gallery__image" alt="">
                </figure>
              </div>`;
            }
          });

          // Fields
          let fieldsHtml = '';
          itemData.fields.forEach(field => (fieldsHtml += `<li class="mt-activity-info__list-item">${field}</li>`));

          // Goals
          let goalsHtml = '';
          itemData.goals.forEach(goal => (goalsHtml += `<li class="mt-activity-info__list-item">${goal}</li>`));

          // Setup (Players, Pods, Duration)
          if (_this.el.modal.setupPlayers) {
            if (itemData.settings.players) {
              _this.el.modal.setupPlayers.querySelector('strong').innerHTML = itemData.settings.players;
              _this.el.modal.setupPlayers.classList.remove('hidden');
            } else {
              _this.el.modal.setupPlayers.classList.add('hidden');
            }
          }
          if (_this.el.modal.setupPods) {
            if (itemData.settings.pods) {
              _this.el.modal.setupPods.querySelector('strong').innerHTML = itemData.settings.pods;
              _this.el.modal.setupPods.classList.remove('hidden');
            } else {
              _this.el.modal.setupPods.classList.add('hidden');
            }
          }
          if (_this.el.modal.setupDuration) {
            if (itemData.settings.duration) {
              _this.el.modal.setupDuration.querySelector('strong').innerHTML = `${itemData.settings.duration / 1000}s`;
              _this.el.modal.setupDuration.classList.remove('hidden');
            } else {
              _this.el.modal.setupDuration.classList.add('hidden');
            }
          }

          _this.modalSlider && _this.modalSlider.destroy(true, true);
          _this.el.modal.title.innerHTML = itemData.name;
          _this.el.modal.authorImage.innerHTML = `<img src="${creatorObj.image}" alt="${itemData.creator}">`;
          _this.el.modal.authorName.innerHTML = itemData.creator;
          _this.el.modal.authorSubtitle.innerHTML = creatorObj ? creatorObj.subtitle : '';
          _this.el.modal.fields.innerHTML = fieldsHtml;
          _this.el.modal.goals.innerHTML = goalsHtml;
          _this.el.modal.galleryWrapper.innerHTML = galleryHtml;

          _this.modalSlider = new Swiper(_this.el.modal.gallerySwiper, {
            slidesPerView: 1,
            spaceBetween: 0,
            direction: 'horizontal',
            speed: 800,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            pagination: {
              el: '.swiper-pagination',
              clickable: true
            }
          });

          app.modal.open(_this.el.modal.el);
        }
      });

      // Item info (mobile)
      const itemInfoBtn = item.querySelector('.mt-activity__info-button');
      itemInfoBtn.addEventListener('click', e => {
        e.preventDefault();
        item.classList.add('active');
      });

      // Item info - close (mobile)
      const itemInfoClose = item.querySelector('.mt-activity-details__close');
      itemInfoClose.addEventListener('click', e => {
        e.preventDefault();
        item.classList.remove('active');
      });
    });

    // Items (width)
    updateItemWidth();
    window.addEventListener('resize', () => updateItemWidth());
  },

  featuredCreators: function () {
    const _this = this;
    if (!_this.el.creatorsSlider) return;

    _this.creatorsSlider = new Swiper(_this.el.creatorsSlider, {
      slidesPerView: 'auto',
      spaceBetween: 10,
      freeMode: true,
      breakpoints: {
        768: {
          freeMode: false,
          slidesPerView: 7
        },
        980: {
          freeMode: false,
          slidesPerView: 8,
          spaceBetween: 30
        },
        1100: {
          freeMode: false,
          slidesPerView: 9
        },
        1200: {
          freeMode: false,
          slidesPerView: 10
        },
        1300: {
          freeMode: false,
          slidesPerView: 11
        }
      },
      navigation: {
        nextEl: '.mt-activities-list__creators-btn--next',
        prevEl: '.mt-activities-list__creators-btn--prev'
      }
    });
  },

  filters: {
    setup: {
      goals: [],
      fields: [],
      createdBy: []
    },
    firstLoad: true,

    update: function (availableFilters = null, filterName = null) {
      app.activitiesList.el.filtersGroups = document.querySelectorAll('.mt-activities-filters__group');
      app.activitiesList.el.filtersGroups.forEach(group => {
        const groupFilters = group.querySelectorAll('.mt-activities-filters__filter');
        groupFilters.forEach(filter => {
          const input = filter.querySelector('input');
          const createdByGroups = app.activitiesList.createdByConfig.filter(group => group.title === input.value);
          const filterValues = (createdByGroups.length > 0) ? createdByGroups[0].includes : [input.value];
          let isVisible = true;

          switch (input.name) {
            case 'which-fields[]':
              isVisible = availableFilters.fields?.includes(input.value);
              break;
            case 'which-goals[]':
              isVisible = availableFilters.goals?.includes(input.value);
              break;
            case 'created-by[]':
              isVisible = availableFilters.createdBy?.some(el => filterValues.includes(el));
              break;
          }

          if (input.name === filterName) return;
          if (availableFilters === null || isVisible) {
            filter.classList.remove('disabled');
          } else {
            filter.classList.add('disabled');
            input.checked = false;

            if (app.activitiesList.filters.firstLoad) {
              filter.classList.add('not-available');
              app.activitiesList.filters.firstLoad = false;
            }
          }
        });
      });
    },

    filter: function (filters = null, filterName = null) {
      const _this = this;
      const inputs = app.activitiesList.el.filters.querySelectorAll('input');
      const items = document.querySelectorAll('.mt-activity');
      const itemsPerPage = Number(app.activitiesList.el.content.dataset.page);
      let availableFilters = null;
      let filteredItems = app.activitiesList.data;

      if (inputs.length === 0 || items.length === 0) return;

      // Clear filters
      _this.setup = (filters !== null) ? filters : { goals: [], fields: [], createdBy: [] };

      // Map active filters
      const activeTopCreators = [...document.querySelectorAll('.mt-featured-creators input:checked')].map(input => input.value);
      _this.setup.createdBy = _this.setup.createdBy.concat(activeTopCreators);

      inputs.forEach(input => {
        if (!input.checked) return;

        const createdByGroups = app.activitiesList.createdByConfig.filter(group => group.title === input.value);
        const filterValues = (createdByGroups.length > 0) ? createdByGroups[0].includes : [input.value];

        switch (input.name) {
          case 'which-goals[]':
            !_this.setup.goals.includes(input.value) && _this.setup.goals.push(input.value);
            break;
          case 'which-fields[]':
            !_this.setup.fields.includes(input.value) && _this.setup.fields.push(input.value);
            break;
          case 'created-by[]':
            filterValues.forEach(value => !_this.setup.createdBy.includes(value) && _this.setup.createdBy.push(value));
            break;
        }
      });

      // Update filters count
      const filtersCount = (_this.setup.goals.length + _this.setup.fields.length + (_this.setup.createdBy.length > 0 ? 1 : 0));
      app.activitiesList.el.filtersToggleBtn.dataset.count = filtersCount;
      (filtersCount > 0) ? app.activitiesList.el.filtersClearBtn.classList.remove('hidden') : app.activitiesList.el.filtersClearBtn.classList.add('hidden');

      // Filter
      Object.keys(_this.setup).forEach(type => {
        let groupIndicator;
        values = _this.setup[type];

        if (type === 'goals') {
          groupIndicator = document.querySelector('.mt-activities-filters__group[data-type="which-goals"] .mt-activities-filters__group-title span');
          (values.length > 0) && (filteredItems = filteredItems.filter(item => item.goals.some(i => _this.setup.goals.includes(i))));
        }
        if (type === 'fields') {
          groupIndicator = document.querySelector('.mt-activities-filters__group[data-type="which-fields"] .mt-activities-filters__group-title span');
          (values.length > 0) && (filteredItems = filteredItems.filter(item => item.fields.some(i => _this.setup.fields.includes(i))));
        }
        if (type === 'createdBy') {
          groupIndicator = document.querySelector('.mt-activities-filters__group[data-type="created-by"] .mt-activities-filters__group-title span');
          (values.length > 0) && (filteredItems = filteredItems.filter(item => _this.setup.createdBy.includes(item.creator)));
        }

        // Set group indicator
        groupIndicator && groupIndicator.setAttribute('data-count', (type === 'createdBy') ? (values.length > 0 ? 1 : 0) : values.length);
      });

      // Show only filtered items
      items.forEach(item => {
        item.classList.add('hidden');
        item.dataset.filterVisible = 0;
      });
      if (filteredItems.length > 0) {
        availableFilters = { goals: [], fields: [], createdBy: [] };
        let visibleItems = 0;
        filteredItems.forEach(item => {
          const itemEl = document.querySelector(`.mt-activity[data-id="${item.id}"]`);
          itemEl.dataset.filterVisible = 1;
          if (visibleItems < itemsPerPage) {
            itemEl.classList.remove('hidden');
            visibleItems++;
          }

          // Get possible filters
          availableFilters.fields = availableFilters?.fields.concat(item.fields.filter(item => !availableFilters.fields.includes(item)));
          availableFilters.goals = availableFilters?.goals.concat(item.goals.filter(item => !availableFilters.goals.includes(item)));
          (!availableFilters.createdBy.includes(item.creator)) && availableFilters?.createdBy.push(item.creator);
        });
        app.activitiesList.el.section.classList.remove('mt-activities-list--empty');
      } else {
        app.activitiesList.el.section.classList.add('mt-activities-list--empty');
      }

      _this.update(availableFilters, (filterName === 'created-by[]') ? null : filterName);
      app.activitiesList.results = filteredItems.length;
      app.activitiesList.loadMore.update();
      document.dispatchEvent(new CustomEvent('mt-activities-filter', {}));
    },

    syncCreators: function () {
      const _this = this;
      const creatorsWrapper = app.activitiesList.el.creators;
      if (!creatorsWrapper) return;

      const allCreators = [...new Set(app.activitiesList.data.map(item => item.creator))];
      let featuredCreators = creatorsWrapper.querySelectorAll('.mt-featured-creators__item');

      featuredCreators.forEach(creator => {
        const creatorInput = creator.querySelector('input');

        // Update input value
        if (!allCreators.includes(creatorInput.value)) {
          const matchedCreator = window.activitiesCreators.find(creator => creator.app_id === creatorInput.dataset.id);
          matchedCreator && (creatorInput.value = matchedCreator.name);
        }

        if (allCreators.includes(creatorInput.value)) {
          creatorInput.addEventListener('change', () => {
            const filterSetup = _this.setup;
            const createdByConfig = app.activitiesList.createdByConfig;
            const createdByMatchedGroup = createdByConfig.filter(g => g.includes.includes(creatorInput.value));
            const createdByGroupInputs = document.querySelectorAll('.mt-activities-filters__group[data-type="created-by"] input');
            let matchedGroupSetup = null;
            filterSetup.createdBy = (creatorInput.checked) ? [creatorInput.value] : [];

            // Check matched group
            if (createdByMatchedGroup.length > 0 && creatorInput.checked) {
              const group = createdByMatchedGroup[0];
              if (group.includes.every(val => val === creatorInput.value)) {
                matchedGroupSetup = { name: group.title, type: 'full' };
              } else {
                matchedGroupSetup = { name: group.title, type: 'partially' };
              }
            }

            createdByGroupInputs.forEach(i => {
              const label = i.closest('.mt-activities-filters__filter');
              if (matchedGroupSetup && matchedGroupSetup.name === i.value) {
                label.classList.toggle('active-partially', matchedGroupSetup.type === 'partially');
                i.checked = matchedGroupSetup.type === 'full';
              } else {
                label.classList.remove('active-partially');
                i.checked = false;
              }
            });
            featuredCreators.forEach(c => (c !== creator && (c.querySelector('input').checked = false)));
            _this.filter(filterSetup);
          });
        } else {
          creator.closest('.swiper-slide').remove();
        }
      });

      featuredCreators = creatorsWrapper.querySelectorAll('.mt-featured-creators__item');
      if (featuredCreators.length > 0) {
        creatorsWrapper.classList.remove('hidden');
      } else {
        creatorsWrapper.remove();
      }

      document.addEventListener('mt-activities-filter', () => {
        const createdByGroupInputs = document.querySelectorAll('.mt-activities-filters__group[data-type="created-by"] input:checked');
        const createdByPartially = document.querySelectorAll('.mt-activities-filters__group[data-type="created-by"] .mt-activities-filters__filter.active-partially');
        if (createdByGroupInputs.length > 0) {
          const activeCreators = [...createdByGroupInputs].map(input => input.value);
          featuredCreators.forEach(creator => {
            const creatorInput = creator.querySelector('input');
            const inputValue = (creatorInput.value === 'BlazePod') ? 'BlazePod Activities' : creatorInput.value;
            creatorInput.checked = activeCreators.includes(inputValue);
          });
        } else if (createdByPartially.length === 0) {
          featuredCreators.forEach(c => (c.querySelector('input').checked = false));
        }
      });
    },

    init: function () {
      const _this = app.activitiesList;

      // Render filters
      _this.filtersData.forEach(({ group_name, element }, i) => {
        const gr_name = window.activitiesFilters.names[group_name] ? window.activitiesFilters.names[group_name] : group_name;

        const group = document.createElement('details');
        group.classList = 'mt-activities-filters__group';
        group.dataset.type = window.app.activitiesList.handleize(gr_name);

        const groupTitle = document.createElement('summary');
        groupTitle.classList = 'mt-activities-filters__group-title';
        groupTitle.innerHTML = `${gr_name}<span></span>`;

        const groupContent = document.createElement('div');
        groupContent.classList = 'mt-activities-filters__group-content';

        element.forEach(el => {
          groupContent.innerHTML += `<label class="mt-activities-filters__filter">
              <input type="checkbox" name="${window.app.activitiesList.handleize(gr_name)}[]" value="${el}">
              <span class="mt-activities-filters__filter-checkbox"></span>
              <span class="mt-activities-filters__filter-label">${el}</span>
          </label>`;
        });

        group.appendChild(groupTitle);
        group.appendChild(groupContent);
        _this.el.filtersGroupsWrapper.appendChild(group);
      });

      // Filters
      document.addEventListener('click', e => !e.target.closest('.mt-activities-list__filters') && _this.el.section.classList.remove('mt-activities-list--filters'));
      _this.el.filtersToggleBtn.addEventListener('click', () => _this.el.section.classList.toggle('mt-activities-list--filters'));
      _this.el.filtersClearBtn.addEventListener('click', e => {
        e.preventDefault();
        _this.el.filters.querySelectorAll('.mt-activities-filters__filter').forEach(label => {
          label.classList.remove('active-partially');
          label.querySelector('input').checked = false;
        });
        _this.el.creators && _this.el.creators.querySelectorAll('input').forEach(input => (input.checked = false));
        app.activitiesList.filters.filter();
      });
      _this.el.filtersGroups = document.querySelectorAll('.mt-activities-filters__group');
      _this.el.filtersGroups.forEach(group => {
        const summary = group.querySelector('.mt-activities-filters__group-title');
        summary.addEventListener('click', () => _this.el.filtersGroups.forEach(g => (group !== g) && g.removeAttribute('open')));
      });

      // Events
      const inputs = _this.el.filters.querySelectorAll('input');
      inputs.forEach(input => {
        const label = input.closest('.mt-activities-filters__filter');
        input.addEventListener('change', () => {
          label.classList.remove('active-partially');
          _this.filters.filter(null, input.name);
        });
      });
      _this.filters.filter();
      _this.filters.syncCreators();
    }
  },

  loadMore: {
    update: function () {
      const _this = app.activitiesList;
      const hiddenActivities = document.querySelectorAll('.mt-activity.hidden[data-filter-visible="1"]');

      if (hiddenActivities.length === 0) {
        _this.el.loadMoreWrapper.classList.add('hidden');
      } else {
        _this.el.loadMoreWrapper.classList.remove('hidden');
      }
    },

    init: function () {
      const _this = this;
      const itemsPerPage = Number(app.activitiesList.el.content.dataset.page);
      let hiddenActivities = document.querySelectorAll('.mt-activity.hidden[data-filter-visible="1"]');

      app.activitiesList.el.loadMore.addEventListener('click', e => {
        e.preventDefault();

        hiddenActivities = document.querySelectorAll('.mt-activity.hidden[data-filter-visible="1"]');
        if (hiddenActivities.length > 0) {
          for (let i = 0; i < itemsPerPage; i++) {
            hiddenActivities[i] && hiddenActivities[i].classList.remove('hidden');
          }
          hiddenActivities = document.querySelectorAll('.mt-activity.hidden[data-filter-visible="1"]');
          _this.update();
        }
      });

      _this.update();
    }
  },

  init: async function () {
    const _this = this;
    const now = new Date().getTime();
    let actualData = true;
    (_this.data.length === 0 || _this.filtersData.length === 0) && (actualData = false);
    if (now >= (_this.lastUpdated + 3600000)) {
      actualData = false;
      _this.data = [];
      _this.filtersData = [];
      _this.lastUpdated = null;
    };
    (!actualData) && await _this.fetchActivites();
    _this.render();
    (!actualData) && await _this.fetchFilters();
    _this.filters.init();
    _this.featuredCreators();
  }
}
window.app.activitiesList.init();